<script>
import { mapActions } from "vuex";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "delete-contract-modal",
    },

    // The contract ID possibly being deleted
    contractId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // toggle delete button disabled
      delDisabled: false,
    };
  },

  methods: {
    // Delete the worker, hide the modal, and go to the workers page
    async doDelete() {
      this.delDisabled = true;
      await this.deleteContract({ contractId: this.contractId });
      this.delDisabled = false;
      this.hide();
      this.$router.push("/contracts");
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["deleteContract"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Confirm Delete"
    button-size="sm"
    hide-header-close
  >
    <p>
      Are you sure you want to delete this contract? Doing so will also delete
      all its historical data.
    </p>
    <p>
      Any miner that is connected to mine.app using this contract will also be
      affected.
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button :disabled="delDisabled" variant="danger" @click="doDelete">
          Delete
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
